// TSS vite/03 §"Query keys".

export const birthKeys = {
    all: ['births'],
    list: (filters) => ['births', 'list', filters],
    detail: (id) => ['births', 'detail', id],
};
